const URLconfig = {
  //API_BASE_URL: "https://localhost:44363/",
  //BASE_URL: "http://192.168.0.31/",
  API_BASE_URL: "https://srs.bue.edu.eg/BUEPoliciesBE/",
};

export default URLconfig;
